const RouteNames = {
  Home: 'dashboard',
  Component: 'component',
  Procedure: 'procedure',
  Recurring: 'recurring',
  Invoices: 'invoices',
  PhysicianSignOff: 'physicianSignOff',
  OrderSearchReport: 'advanceSearch',
  NDCSearchReport: 'NDCReportSearch',
  ReturnProduct: 'returnProduct',
  AccountSetting: 'accountSetting',
  Alerts: 'alerts',
  ManageAlerts:'alerts',
  Reservations:'reservation',
  Order340BReport: 'order340bReport',
  PatientEnrollment: 'patientenrollment',
} 

export enum MasterRoutes {
  Okta = '',
  Module = '',
  Home = 'dashboard',
  Configure = 'configure',
  Reports = 'reports',
  MyAccount = 'my-account',
  Alerts = 'alerts',
  PatientEnrollment = 'patient-enrollment'
}

export const HomeRoutes = {
  Home: {
    Name: RouteNames.Home,
    Url: MasterRoutes.Module + '/' + RouteNames.Home,
  },
}

export const ConfigureRoutes = {
  Components: {
    Name: RouteNames.Component,
    Url: MasterRoutes.Configure + '/' + RouteNames.Component,
  },
  Procedures: {
    Name: RouteNames.Procedure,
    Url: MasterRoutes.Configure + '/' + RouteNames.Procedure,
  },
  RecurringOrder: {
    Name: RouteNames.Recurring,
    Url: MasterRoutes.Configure + '/' + RouteNames.Recurring,
  }
}

export const ModuleRoutes = {
  Dashboard: {
    Name: MasterRoutes.Home,
    Url: MasterRoutes.Module + '/' + MasterRoutes.Home,
  },
  MyAccount: {
    Name: MasterRoutes.MyAccount,
    Url: MasterRoutes.Module + '/' + MasterRoutes.MyAccount,
  },
  Alerts: {
    Name: MasterRoutes.Alerts,
    Url: MasterRoutes.Module + '/' + MasterRoutes.Alerts,
  },
  PatientEnrollment: {
    Name: MasterRoutes.PatientEnrollment,
    Url: MasterRoutes.Module + '/' + MasterRoutes.PatientEnrollment,
  },
}

export const ReportsRoutes = {
  Invoices: {
    Name: RouteNames.Invoices,
    Url: MasterRoutes.Reports + '/' + RouteNames.Invoices,
  },
  PhysicianSignOff: {
    Name: RouteNames.PhysicianSignOff,
    Url: MasterRoutes.Reports + '/' + RouteNames.PhysicianSignOff,
  },
  OrderSearchReport: {
    Name: RouteNames.OrderSearchReport,
    Url: MasterRoutes.Reports + '/' + RouteNames.OrderSearchReport,
  },
  NDCSearchReport: {
    Name: RouteNames.NDCSearchReport,
    Url: MasterRoutes.Reports + '/' + RouteNames.NDCSearchReport,
  },
  ReturnProduct: {
    Name: RouteNames.ReturnProduct,
    Url: MasterRoutes.Reports + '/' + RouteNames.ReturnProduct,
  },
  ReportFor340B: {
    Name: RouteNames.Order340BReport,
    Url: MasterRoutes.Reports + '/' + RouteNames.Order340BReport,
  }
}



export const AlertsRoutes = {
  ManageAlerts: {
    Name: RouteNames.ManageAlerts,
    Url: MasterRoutes.Alerts + '/' + RouteNames.ManageAlerts,
  },
  Reservations: {
    Name: RouteNames.Reservations,
    Url: MasterRoutes.Alerts + '/' + RouteNames.Reservations,
  }
};